export default __webpack_public_path__ + "80a1cc538d993c6192027be8b7f9958e45e7375dc77fe311e24b9b5add418895.svg";